



































import Vue from 'vue'
import { MemberType, Query, Store, User } from '@/types/generated/graphql'
import STORE_LIST_QUERY from '@/graphql/partner/stores.gql'
import XCard from '@/components/atoms/Card/XCard.vue'
import XList from '@/components/atoms/List/XList.vue'
import XListItem from '@/components/atoms/List/XListItem.vue'
import { mapState } from 'vuex'

type Data = {
  partnerId: string
  stores?: Array<Store>
  isOwner: boolean
}

type Computed = {
  user: User
}

export default Vue.extend<Data, {}, Computed, {}>({
  name: 'Stores',
  components: { XCard, XList, XListItem },
  data() {
    return {
      partnerId: this.$route.params.partnerId,
      stores: [],
      isOwner: false,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  created() {
    const member = this.user?.members?.find(() => true)
    if (member?.type === MemberType.Owner) {
      this.isOwner = true
    }
  },
  apollo: {
    stores: {
      query: STORE_LIST_QUERY,
      variables() {
        return {
          input: { partnerId: this.partnerId },
        }
      },
      update(data: Query) {
        this.stores = data.stores.filter((store) => store.affiliateId)

        return this.stores
      },
    },
  },
})
